import * as ActionTypes from "../ActionTypes";
import * as WebService from "../WebService";
import HttpUtils from "../../../utils/HttpUtils";
import { FuzzySearchType, MapSearchRangeEnums, TAGS_TYPE } from "../Enums";

import { GPSMapUtils } from "../../../utils/GPSMapUtils";
import { BMapUtils } from "../../../utils/BMapUtils";
import CityEnList from '../views/Mobile/Zone/components/CityEnList.json'
import Util from "../../../utils/Utils";
import { message } from "antd";
import { CACHE_SESSION_USER } from "../../../constants/Profile";

export function refreshSearchCondition(searchCondition) {
    return {
        type: ActionTypes.WMS_ZONE_REFRESH_SEARCH_CONDITION,
        searchCondition: searchCondition
    }
}

export function toggleDetailModal(isShow) {
    return {
        type: ActionTypes.WMS_ZONE_TOGGLE_DETAIL_MODAL,
        showDetailModal: isShow
    }
}


export function getZone(id, formatMessage) {

    return dispatch => {
        dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: true });

        const requestUrl = WebService.getZone.replace("{id}", id);
        HttpUtils.get(requestUrl, (response) => {
            if (response.data.limit) {

                dispatch({
                    type: ActionTypes.WMS_ZONE_LIMIT,
                    limit: response.data.limit
                });
                return dispatch({
                    type: ActionTypes.WMS_ZONE_REFRESH_ZONE,
                    zone: {},
                });
            }

            const zone = response.data;

            doMapingZoneResponse(zone);

            dispatch({
                type: ActionTypes.WMS_ZONE_REFRESH_ZONE,
                zone: zone
            });
            dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}

//查询房源列表
export function searchZoneListView(condition, oldZoneListView, zoneCoordinateMap, formatMessage, intercept) {
    return dispatch => {
        dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: true });
        dispatch(refreshSearchCondition(condition));

        let searchCondition = Object.assign({}, condition);
        searchCondition.zonePointWest = undefined;
        searchCondition.zonePointEast = undefined;//东
        searchCondition.zonePointSouth = undefined;//南
        searchCondition.zonePointNorth = undefined;//北
        if (searchCondition.zoneDeliverDate) {
            // 现在是YYYYMM 拼接成 YYYYMM01
            searchCondition.zoneDeliverDate = searchCondition.zoneDeliverDate + "01";
        }

        searchCondition = Util.cleanObject(searchCondition)

        dispatch(getZonesCountByCondition({
            withoutBasicCondition: true,
            zoneCity: searchCondition.zoneCity,
            brandId: searchCondition.brandId,
            town: searchCondition.town
        }));


        // let url = intercept ? WebService.searchZoneListIntercept : WebService.searchZoneList;
        let url = WebService.searchZoneList;
        HttpUtils.post(url, searchCondition, (response) => {
            if (response.data.limit) {

                dispatch({
                    type: ActionTypes.WMS_ZONE_LIMIT,
                    limit: response.data.limit
                });
                return dispatch({
                    type: ActionTypes.WMS_ZONE_LIST,
                    zoneList: [],
                    pagination: {},
                });
            }

            youmengMD(searchCondition, '列表页')

            dispatch({
                type: ActionTypes.WMS_ZONE_LIMIT,
                limit: ''
            });

            let zoneList = response.data;
            zoneList.forEach(zone => {
                if (zoneCoordinateMap) {
                    if (zoneCoordinateMap[zone.id]) {
                        zone.longitude = zoneCoordinateMap[zone.id].longitude;
                        zone.latitude = zoneCoordinateMap[zone.id].latitude;
                    } else {
                        zoneCoordinateMap[zone.id] = {
                            longitude: zone.longitude,
                            latitude: zone.latitude
                        }
                    }
                } else {
                    zoneCoordinateMap = {};
                    zoneCoordinateMap[zone.id] = {
                        longitude: zone.longitude,
                        latitude: zone.latitude
                    }
                }
                doMapingZoneResponse(zone, searchCondition);

            });

            const newData = oldZoneListView.concat(zoneList);
            dispatch({
                type: ActionTypes.WMS_ZONE_LIST,
                zoneList: newData,
                // searchCondition: condition,
                pagination: response.pagination
            });
            // // 缓存坐标，重复的不覆盖
            if (zoneCoordinateMap && zoneList.length > 0) {
                dispatch({
                    type: ActionTypes.WMS_ZONE_REFRESH_COORDINATE_MAP,
                    zoneCoordinateMap: zoneCoordinateMap
                });
            }

            dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: false });
        }, (response) => {
        }, formatMessage)
    }
}


export function searchBrandList() {
    return dispatch => {

        HttpUtils.get(WebService.searchBrandList, (response) => {
            // console.log(response.data);
            dispatch(refreshBrandList(response.data));
        }, (response) => {
        })
    }
}

export function refreshBrandList(result) {
    return {
        type: ActionTypes.WMS_ZONE_REFRESH_BRAND_LIST,
        brandList: result
    }
}


export function doMapingZoneResponse(zone, searchCondition) {
    if (zone.photos && zone.photos !== "") {
        let photos = JSON.parse(zone.photos);
        let photoFiles = photos.filter(photo => photo.activeFlag === 1);
        let mainPhoto;
        if (photoFiles.length > 0) {

            let photoFileList = [];

            photoFiles.forEach(item => {
                let photoUrl = item.url;
                if (photoUrl.startsWith("http:")) {
                    photoUrl = photoUrl.replace("http:", "https:");
                    item.url = photoUrl;
                }
                if (item.mainFlag === 1 && mainPhoto === undefined) {
                    mainPhoto = item;
                } else {
                    photoFileList.push(item);
                }
            });
            photoFiles = [];
            if (mainPhoto) {
                photoFiles.push(mainPhoto);
            }
            if (photoFileList.length > 0) {
                photoFiles = photoFiles.concat(photoFileList);
            }
        }
        zone.mainPhoto = mainPhoto;
        zone.photoFiles = photoFiles;
    } else {
        zone.photoFiles = [];
    }
    if (searchCondition && searchCondition.rectangleCenterPointLng && searchCondition.rectangleCenterPointLat &&
        searchCondition.rectangleCenterPointLng !== null && searchCondition.rectangleCenterPointLat !== null) {
        zone.centerDistance = GPSMapUtils.distance(searchCondition.rectangleCenterPointLat, searchCondition.rectangleCenterPointLng, zone.latitude, zone.longitude);

    }

    // let tagsList = [];
    // if (zone.propertyGrade === '02' || zone.propertyGrade === '03') {
    //     tagsList.push(TAGS_TYPE.Enum.Grade2)
    // } else {
    //     tagsList.push(TAGS_TYPE.Enum.Grade1)
    // }
    // if (zone.isMultipleUnloadingFlag) {
    //     tagsList.push(TAGS_TYPE.Enum.MultipleUnloading)
    // }
    // if (zone.isMultipleUnloadingFlag) {
    //     tagsList.push(TAGS_TYPE.Enum.MultipleUnloading)
    // }
    // if (zone.isDoubleUnloadingFlag) {
    //     tagsList.push(TAGS_TYPE.Enum.DuplicateUnloading)
    // }
    // if (zone.isOutsidePlatformFlag) {
    //     tagsList.push(TAGS_TYPE.Enum.PlatformOutside)
    // }
    // if (zone && zone.tags) {
    //     let tagList2 = zone.tags //.split(",");
    //     tagsList = tagsList.concat(tagList2)
    // }

    // zone.tagList = tagsList;
}


export function refreshCityName(cityName) {
    return {
        type: ActionTypes.WMS_ZONE_REFRESH_CITY_NAME,
        cityName: cityName
    }
}

export function refreshCurrentLocation(currentLocation) {
    return {
        type: ActionTypes.WMS_ZONE_REFRESH_CURRENT_LOCATION,
        currentLocation: currentLocation
    }
}


export function initialWebWillMount(props, refreshFunction) {
    let searchCondition = Object.assign({}, props.searchCondition);
    const city = props.cityName;
    //当前的城市名
    if (city) {
        props.dispatch(refreshCityName(city));
        searchCondition.zoneCity = city;

        props.dispatch(refreshSearchCondition(searchCondition));
        //查询当前城市所有的行政区域内仓库总数
        if (refreshFunction) {
            refreshFunction.call(this, city, searchCondition);
        }
        return
    }

    if (window.__wxjs_environment === 'miniprogram') {
        let latString = HttpUtils.getQueryString('lat');
        let lngString = HttpUtils.getQueryString('lng');
        if (latString && lngString && latString !== "" && lngString !== "") {
            let point = GPSMapUtils.chinaToBaidu2(parseFloat(latString), parseFloat(lngString));
            // props.dispatch(refreshCurrentLocation(point));
            // 没有指定城市，则通过定位获取城市
            getCityName(point.lat, point.lng, ({ cityName, lng, lat }) => {
                props.dispatch(refreshCityName(cityName));
                searchCondition.zoneCity = cityName;
                props.dispatch(refreshSearchCondition(searchCondition));
                props.dispatch(refreshCurrentLocation({
                    lng,
                    lat
                }));
                //查询当前城市所有的行政区域内仓库总数
                if (refreshFunction) {
                    refreshFunction.call(this, cityName, searchCondition);
                }
            })
        }
    } else {

        navigator.geolocation.getCurrentPosition((pos) => {
            let coords = pos.coords || {};
            let point = GPSMapUtils.chinaToBaidu2(coords.latitude, coords.longitude);
            // props.dispatch(refreshCurrentLocation(point));
            // 没有指定城市，则通过定位获取城市
            if (!city || city === '') {

                getCityName(point.lat, point.lng, ({ cityName, lng, lat }) => {
                    props.dispatch(refreshCityName(cityName));
                    searchCondition.zoneCity = cityName;
                    props.dispatch(refreshSearchCondition(searchCondition));
                    props.dispatch(refreshCurrentLocation({
                        lng,
                        lat
                    }));
                    //查询当前城市所有的行政区域内仓库总数
                    if (refreshFunction) {
                        refreshFunction.call(this, cityName, searchCondition);
                    }
                })

            } else {
                searchCondition.zoneCity = city;
                if (refreshFunction) {
                    refreshFunction.call(this, city, searchCondition);
                }
            }
        }, (err) => {
            message.info('获取定位失败，请授权获取定位信息');
            let cityName = '上海市'
            props.dispatch(refreshCurrentLocation({
                lng: 121.474000,
                lat: 31.230001
            }));
            //当前的城市名
            props.dispatch(refreshCityName(cityName));
            searchCondition.zoneCity = cityName;
            props.dispatch(refreshSearchCondition(searchCondition));
            //查询当前城市所有的行政区域内仓库总数
            if (refreshFunction) {
                refreshFunction.call(this, cityName, searchCondition);
            }

        }, {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        })
    }
}

// 使用百度地图 API 获取城市名称
function getCityName(lat, lng, callBack) {
    const point = new window.BMap.Point(lng, lat); // 创建百度地图点对象
    const geocoder = new window.BMap.Geocoder(); // 创建地理编码器

    geocoder.getLocation(point, function (result) {
        console.log('result', result)
        let params = {
            cityName: '上海市',
            lng: 121.474000,
            lat: 31.230001
        }
        if (result) {
            const city = result.addressComponents.city;
            let hasCity = CityEnList.list.some(item => item.value === city)
            if (hasCity) {
                params = {
                    cityName: city,
                    lng,
                    lat
                }
            }

        }
        console.log('params', params)
        callBack && callBack(params)
    }, {
        poiRadius: 0,          // 不显示周边POI
        numPois: 0             // 不需要周边POI数量
    });
}


export function searchMapZoneList(searchCondition, zoneCoordinateMap, selectedZoneId, limitCallBack) {
    return dispatch => {
        dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: true });
        dispatch(refreshSearchCondition(searchCondition));


        let condition = Object.assign({}, searchCondition);
        condition.mapSearchRange = undefined;
        HttpUtils.post(WebService.searchZoneList, condition, (response) => {

            if (response.data.limit) {

                dispatch({
                    type: ActionTypes.WMS_ZONE_LIMIT,
                    limit: response.data.limit
                });
                dispatch({
                    type: ActionTypes.WMS_ZONE_LIST,
                    zoneList: [],
                    pagination: {},
                });
                limitCallBack && limitCallBack()
                return
            }


            youmengMD(searchCondition, '地图页')

            dispatch({
                type: ActionTypes.WMS_ZONE_LIMIT,
                limit: ''
            });

            let zones = response.data;

            zones.forEach(zone => {
                if (searchCondition && searchCondition.rectangleCenterPointLng && searchCondition.rectangleCenterPointLat &&
                    searchCondition.rectangleCenterPointLng !== null && searchCondition.rectangleCenterPointLat !== null) {
                    zone.centerDistance2 = GPSMapUtils.distance(searchCondition.rectangleCenterPointLat, searchCondition.rectangleCenterPointLng, zone.latitude, zone.longitude);

                }
                if (zoneCoordinateMap) {
                    if (zoneCoordinateMap[zone.id]) {
                        zone.longitude = zoneCoordinateMap[zone.id].longitude;
                        zone.latitude = zoneCoordinateMap[zone.id].latitude;
                    } else {
                        zoneCoordinateMap[zone.id] = {
                            longitude: zone.longitude,
                            latitude: zone.latitude
                        }
                    }
                } else {
                    zoneCoordinateMap = {};
                    zoneCoordinateMap[zone.id] = {
                        longitude: zone.longitude,
                        latitude: zone.latitude
                    }
                }

                doMapingZoneResponse(zone, searchCondition);
            });
            if (zones.length > 0) {
                let thisId;
                if (selectedZoneId) {
                    zones.forEach(zone => {
                        if (zone.id === selectedZoneId) {
                            thisId = selectedZoneId;
                        }
                    });

                }
                if (thisId === undefined) {
                    thisId = zones[0].id;
                }
                dispatch(refreshSelectedZoneId(thisId))
            }


            // if (isFirstSearch && zones.length === 0) {
            //     dispatch(toggleRetrySearchModal(true));
            // }
            dispatch({
                type: ActionTypes.WMS_ZONE_MAP_REFRESH_ZONE_LIST,
                bMapZoneList: zones,
                pagination: response.pagination,
            });

            // // 缓存坐标，重复的不覆盖
            if (zoneCoordinateMap && zones.length > 0) {
                dispatch({
                    type: ActionTypes.WMS_ZONE_REFRESH_COORDINATE_MAP,
                    zoneCoordinateMap: zoneCoordinateMap
                });
            }


            dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: false });
        }, (response) => {
            dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: false });
        })
    }
}

/**
 *在无情况下的区域汇总数值
 */
export function refreshZoneDistrictTotal(zoneDistrictTotal) {
    return {
        type: ActionTypes.WMS_ZONE_MAP_REFRESH_SUMMARY_DISTRICT,
        zoneDistrictTotal: zoneDistrictTotal
    }
}

/**
 *在查询条件的情况下的区域汇总数值
 */
export function refreshZoneDistrictTotalWithCondition(zoneDistrictTotalWithCondition) {
    return {
        type: ActionTypes.WMS_ZONE_MAP_REFRESH_SUMMARY_DISTRICT_WITH_CONDITION,
        zoneDistrictTotalWithCondition: zoneDistrictTotalWithCondition
    }
}

export function refreshSearchMapSelectedDistrictList(selectedDistrictList) {
    return {
        type: ActionTypes.WMS_ZONE_MAP_REFRESH_SELECTED_DISTRICT_LIST,
        selectedDistrictList: selectedDistrictList
    }

}

//控制地图是聚合状态，还是描点状态
export function refreshZoneMapShowPointFlag(showPointFlag) {
    return {
        type: ActionTypes.WMS_ZONE_MAP_REFRESH_SHOW_POINT_FLAG,
        showPointFlag: showPointFlag
    }
}

export function refreshSelectedZoneId(selectedZoneId) {
    return {
        type: ActionTypes.WMS_ZONE_MAP_REFRESH_SELECTED_ZONE_ID,
        selectedZoneId: selectedZoneId
    }
}


export function getAllCountiesByCityName(cityName, formatMessage) {
    return dispatch => {
        dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: true });

        let requestURL = WebService.getCountiesByCityName.replace("{cityName}", cityName);
        requestURL = requestURL + "&simpleFlag=" + false;
        HttpUtils.get(requestURL, (response) => {

            let allCounties = response.data;
            allCounties.forEach((item, index) => {
                let locationRangList = item.locationRang && item.locationRang.includes("$") ? item.locationRang.split("$") : [item.locationRang];
                item.locationRangList = locationRangList;
            })

            dispatch({
                type: ActionTypes.WMS_ZONE_REFRESH_ALL_COUNTIES,
                allCounties: allCounties
            });

            dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: false });

        }, (response) => {
        }, formatMessage)
    }
}


export function getZoneDistrictTotal(searchCondition) {
    return dispatch => {
        dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: true });
        let districtCondition = Object.assign({}, searchCondition);
        districtCondition.zonePointWest = null;
        districtCondition.zonePointEast = null;
        districtCondition.zonePointSouth = null;
        districtCondition.zonePointNorth = null;
        districtCondition.zoneDistrictList = [];
        districtCondition.mapSearchRange = null;
        districtCondition.fuzzy = '';
        districtCondition.zoneAddress = '';

        districtCondition.town = '';
        districtCondition.district = '';


        HttpUtils.post(WebService.getZoneDistrictTotal, districtCondition, (response) => {
            dispatch(refreshZoneDistrictTotalWithCondition(response.data));
            dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: false });
        }, (response) => {
            dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: false });
        })
    }
}

/**
 * 根据城市获取每个区域里的总房源数
 * @param cityName
 * @returns {(function(*): void)|*}
 */
export function getZoneDistrictTotalByCity(cityName) {
    return dispatch => {
        let searchCondition = { zoneCity: cityName };

        dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: true });

        HttpUtils.post(WebService.getZoneDistrictTotal, searchCondition, (response) => {
            let zoneDistrictTotal = response.data;
            zoneDistrictTotal = zoneDistrictTotal.filter(zoneDistrict => zoneDistrict.count > 0);
            dispatch(refreshZoneDistrictTotal(zoneDistrictTotal));
            dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: false });
        }, (response) => {
            dispatch({ type: ActionTypes.WMS_ZONE_LOADING, isLoading: false });
        })
    }
}


//根据模糊查询的结果，获取描绘的结果
export function getAddressItemListRenderInfo(searchCondition, mapSearchConditionList, brandList, districtTownList) {
    let addrList = [];
    let fuzzyValue = searchCondition.fuzzy;
    if (!fuzzyValue) {
        return addrList;
    }
    fuzzyValue = fuzzyValue.trim();

    let brandAddressList = brandList
        .filter(brand => brand.nameZh1 === fuzzyValue)
        .map(brand => ({
            id: brand.id,
            title: brand.nameZh1,
            type: FuzzySearchType.Enums.Brand,
            point: { lng: 0, lat: 0 },
            district: ""
        }));
    let mapResultAddressList = mapSearchConditionList
        .map(mapResultItem => ({
            id: "",
            title: mapResultItem.title,
            type: FuzzySearchType.Enums.Location,
            point: mapResultItem.point,
            district: ""
        }));
    let districtAddressList = districtTownList.filter(item => item.town.indexOf(fuzzyValue) === 0)
        .map(item => {
            return {
                id: "",
                title: item.town,
                type: FuzzySearchType.Enums.Town,
                point: { lng: item.longitude, lat: item.latitude },
                district: item.district

            };
        });
    let districtMapAddressList = districtTownList
        .filter(item => item.town.indexOf(fuzzyValue) !== 0 && item.town.includes(fuzzyValue))
        .map(item => {
            return {
                id: "",
                title: item.town,
                type: FuzzySearchType.Enums.Location,
                point: { lng: item.longitude, lat: item.latitude },
                district: item.district
            };
        });
    // addrList = addrList.concat(brandAddressList);
    //
    // if (brandAddressList.length > 0) {
    //     if (districtAddressList.length > 0) {
    //         addrList.push({type: ""});
    //     }
    //     addrList = addrList.concat(districtAddressList);
    // } else {
    //     addrList = addrList.concat(districtAddressList);
    //     if (districtAddressList.length > 0) {
    //         addrList.push({type: ""});
    //     }
    //     addrList.push({
    //         id: "",
    //         title: fuzzyValue,
    //         type: FuzzySearchType.Enums.Address,
    //         point: {lng: 0, lat: 0},
    //         district: ""
    //     });
    // }
    addrList = addrList.concat(brandAddressList);
    if (brandAddressList.length > 0) {
        if (mapResultAddressList.length > 0 || districtAddressList.length > 0 || districtMapAddressList.length > 0) {
            addrList.push({ type: "" });
        }
        addrList = addrList.concat(mapResultAddressList);
        if (mapResultAddressList.length > 0 && (districtAddressList.length > 0 || districtMapAddressList.length > 0)) {
            addrList.push({ type: "" });
        }
        addrList = addrList.concat(districtAddressList);
        if (districtAddressList.length > 0 && districtMapAddressList.length > 0) {
            addrList.push({ type: "" });
        }
        addrList = addrList.concat(districtMapAddressList);

    } else {
        addrList = addrList.concat(districtAddressList);
        if (districtAddressList.length > 0 && (districtMapAddressList.length > 0 || mapResultAddressList.length > 0)) {
            addrList.push({ type: "" });
        }
        addrList = addrList.concat(districtMapAddressList);
        if (districtMapAddressList.length > 0 && mapResultAddressList.length > 0) {
            addrList.push({ type: "" });
        }
        // addrList.push({
        //     id: "",
        //     title: fuzzyValue,
        //     type: FuzzySearchType.Enums.Address,
        //     point: { lng: 0, lat: 0 },
        //     district: ""
        // });
        if (mapResultAddressList.length > 0) {
            addrList.push({ type: "" });
        }
        addrList = addrList.concat(mapResultAddressList);
    }
    return addrList;
}

//刷新条件相关所属仓库数
export function refreshZonesCountByCondition(zonesCount) {
    return {
        type: ActionTypes.WMS_ZONE_REFRESH_ZONE_COUNT_BY_CONDITION,
        zonesCountByCondition: zonesCount
    }
}

/**
 * 获取品牌所属仓库数
 * @param searchCondition
 * @returns {(function(*): void)|*}
 */
export function getZonesCountByCondition(searchCondition) {
    return dispatch => {

        HttpUtils.post(WebService.getZoneCount, searchCondition, (response) => {

            dispatch(refreshZonesCountByCondition(response.data.zonesCount));
        }, (response) => {
            dispatch(refreshZonesCountByCondition(0));
        })
    }
}

export function doClearSearchConditionForFuzzy(searchCondition) {
    if (searchCondition.searchFuzzyType === FuzzySearchType.Enums.Location) {
        searchCondition.zonePointWest = undefined;
        searchCondition.zonePointEast = undefined;//东
        searchCondition.zonePointSouth = undefined;//南
        searchCondition.zonePointNorth = undefined;//北
        searchCondition.rectangleCenterPoint = undefined;
        searchCondition.mapSearchRange = undefined;

        searchCondition.mapFuzzy = undefined;
        // this.props.dispatch(refreshZoneMapRectangleShowValue(searchCondition.mapSearchRange));
    }
    searchCondition.fuzzyList = [];
    searchCondition.fuzzy = "";

    searchCondition.zoneAddress = "";
    searchCondition.brandId = "";
    searchCondition.town = "";
    searchCondition.zoneDistrictList = [];
    searchCondition.searchFuzzyType = '' //FuzzySearchType.Enums.Default;
    searchCondition.searchFuzzyInfo = "";


}

export function doFillRectangleForSearchCondition(searchCondition, centerPoint, showRangeValue) {


    const range = BMapUtils.calculateRangeWithOutBMap(showRangeValue, centerPoint);

    searchCondition["zonePointWest"] = range.zonePointWest;//西
    searchCondition["zonePointEast"] = range.zonePointEast;//东
    searchCondition["zonePointSouth"] = range.zonePointSouth;//南
    searchCondition["zonePointNorth"] = range.zonePointNorth;//北

}

export function handleClickAddressItem(cityName, addrItem, searchCondition, dispatch) {
    doClearSearchConditionForFuzzy(searchCondition);

    searchCondition.searchFuzzyType = addrItem.type;
    searchCondition.searchFuzzyInfo = addrItem.title;
    searchCondition.fuzzy = addrItem.title;

    if (addrItem.type === FuzzySearchType.Enums.Brand) {
        //用品牌名称搜索物业
        searchCondition.brandId = addrItem.id;
        //设基础条件
        dispatch(getZonesCountByCondition({
            zoneCity: cityName,
            brandId: addrItem.id,
            withoutBasicCondition: true
        }));
    } else if (addrItem.type === FuzzySearchType.Enums.Town) {
        searchCondition.town = addrItem.title;
        searchCondition.zoneDistrictList = [addrItem.district];

        dispatch(getZonesCountByCondition({
            zoneCity: cityName,
            district: searchCondition.district,
            town: searchCondition.town,
            withoutBasicCondition: true
        }));
    }
    else if (addrItem.type === FuzzySearchType.Enums.Address) {
        searchCondition.zoneAddress = addrItem.title;
        // searchCondition.zoneDistrictList = [addrItem.district];

        dispatch(getZonesCountByCondition({
            zoneCity: cityName,
            zoneAddress: addrItem.title,
            withoutBasicCondition: true
        }));
    } else if (addrItem.type === FuzzySearchType.Enums.Location) {
        searchCondition.rectangleCenterPointLng = addrItem.point.lng;
        searchCondition.rectangleCenterPointLat = addrItem.point.lat;

        searchCondition.mapSearchRange = 5;

        searchCondition.zonePointWest = undefined;
        searchCondition.zonePointEast = undefined;//东
        searchCondition.zonePointSouth = undefined;//南
        searchCondition.zonePointNorth = undefined;//北
        searchCondition.rectangleCenterPoint = undefined;

        // doFillRectangleForSearchCondition(searchCondition, addrItem.point, searchCondition.mapSearchRange);

        dispatch(getZonesCountByCondition({
            zoneCity: cityName,
            withoutBasicCondition: true,
            mapSearchRange: 5,
            rectangleCenterPointLng: searchCondition.rectangleCenterPointLng,//西
            rectangleCenterPointLat: searchCondition.rectangleCenterPointLat,//东

        }));
    }
    else {

        if (!searchCondition.mapSearchRange) {
            searchCondition.mapSearchRange = MapSearchRangeEnums.Enum.RANGE_5;
            // dispatch(refreshZoneMapRectangleShowValue(MAP_SEARCH_RANGE_DATA.Enum.RANGE_5));
        }
        searchCondition["rectangleCenterPoint"] = Object.assign({}, addrItem.point);
        // dispatch(refreshZoneMapRectangleCenterPoint(addrItem.point));

        doFillRectangleForSearchCondition(searchCondition, addrItem.point, searchCondition.mapSearchRange);

        dispatch(getZonesCountByCondition({
            zoneCity: cityName,
            withoutBasicCondition: true,
            zonePointWest: searchCondition.zonePointWest,//西
            zonePointEast: searchCondition.zonePointEast,//东
            zonePointSouth: searchCondition.zonePointSouth,//南
            zonePointNorth: searchCondition.zonePointNorth,//北
        }));
    }

    // dispatch()(searchCondition);
    dispatch(refreshSearchCondition(searchCondition));
    // dispatch(refreshZoneRefreshFuzzyShowResultListFlag(false));
    // youmengMD('',searchCondition)
}

export function youmengMD(searchCondition, title) {
    let isWechat = window.__wxjs_environment === 'miniprogram'

    const userInfo = JSON.parse(localStorage.getItem(CACHE_SESSION_USER))

    let category = (isWechat ? "新小程序" : "新H5") + `-${title}` + `${searchCondition.searchFuzzyInfo ? '参考坐标点：' + searchCondition.searchFuzzyInfo : ''} `;
    let action = `用户信息：${userInfo && userInfo.mobile ? userInfo.lastName + userInfo.firstName + ':' + userInfo.mobile : '未登录'}`
    let label = `参数：${JSON.stringify(Util.cleanObject(searchCondition))}`
    window._CSZ.push(["_trackEvent", category, action, label]);

}



export function getDistrictTownList(cityName) {
    return dispatch => {
        let requestUrl = HttpUtils.addQueryString(WebService.getDistrictTownList, "cityName", cityName);
        HttpUtils.get(requestUrl, (response) => {
            // console.log(response.data);
            dispatch(refreshDistrictTownList(response.data));
        }, (response) => {
        })
    }
}

export function refreshDistrictTownList(result) {
    return {
        type: ActionTypes.WMS_ZONE_REFRESH_ALL_TOWN_LIST,
        districtTownList: result
    }
}

export function refreshZoneListScrollTop(scrollTop) {
    return {
        type: ActionTypes.WMS_ZONE_LIST_REFRESH_SCROLL_TOP,
        listScrollTop: scrollTop
    }
}

export function refreshZoneMapCenterZoom(mapCenterZoom) {
    return {
        type: ActionTypes.WMS_ZONE_MAP_REFRESH_CENTER_ZOOM,
        mapCenterZoom: mapCenterZoom
    }
}


export function refreshFuzzyBampResultList(searchFuzzyBampResultList) {
    return {
        type: ActionTypes.WMS_ZONE_SEARCH_FUZZY_BAMP_SEARCH_RESULT,
        searchFuzzyBampResultList: searchFuzzyBampResultList,

    }
}

export function addZoneBrowsingHistories(zoneId) {
    return dispatch => {
        let requestUrl = WebService.addZoneBrowsingHistories;
        HttpUtils.post(requestUrl, { zoneId: zoneId }, (response) => {
            console.log(response.data)
        }, (response) => {
        })
    }
}